<template>
  <div v-if="visible" class="app-loading">
    <div class="app-loading__overlay" :style="overlayStyle"></div>
    <div class="app-loading__spinner">
      <app-loading-icon :color="spinnerStyle.color" />
      <p v-if="message" class="app-loading__spinner-message">{{ message }}</p>
    </div>
  </div>
</template>

<script setup>
import AppLoadingIcon from 'components/AppLoadingIcon.vue'
import { ref } from 'vue'

const visible = ref(false)
const message = ref('')
const overlayStyle = ref({})
const spinnerStyle = ref({})

const show = (options = {}) => {
  message.value = options.message || ''
  overlayStyle.value = {
    background: options.backgroundColor || 'rgba(0, 0, 0, 0.5)',
  }
  spinnerStyle.value = {
    color: options.spinnerColor ? options.spinnerColor : 'var(--cas-button)',
  }
  visible.value = true
}

const hide = () => {
  visible.value = false
}

defineExpose({ show, hide })
</script>

<style lang="scss">
.app-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;

  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    z-index: -1;
  }
  &__spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: 4px;
    padding: 18px;
    max-width: 450px;
    color: #fff;

    &-message {
      margin: 40px 20px 0;
      text-align: center;
      font-size: 14px;
    }
  }
}
</style>
